export function InitialStateFactory(customState) {
  return {
    list: [],
    current: null,
    ...customState,
  };
}
